import { render, staticRenderFns } from "./OrderPartnerEdit.vue?vue&type=template&id=49fe4220&scoped=true&"
import script from "./OrderPartnerEdit.vue?vue&type=script&lang=js&"
export * from "./OrderPartnerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fe4220",
  null
  
)

export default component.exports